import clsx from 'clsx';
import React from 'react';
import { useAlgo } from '../../hooks/useAlgo';
import { CityBuilderProvider, useCityBuilder } from '../../hooks/useCityBuilder';
import { useMyCities } from '../../hooks/useMyCities';
import ConnectWalletMessage from '../ConnectWalletMessage';
import Container from '../Container';
import Steps from '../Steps';
import CityBuilderCityConfirm from './CityBuilderCityConfirm';
import CityBuilderCitySelector from './CityBuilderCitySelector';
import CityBuilderCityEditor from './CityBuilderEditor';

const LocalCityBuilder = () => {
  const { address } = useAlgo();
  const { activeStep } = useCityBuilder();
  const { allCities, myCities } = useMyCities();

  if (!address) {
    return (
      <div className='flex justify-center mt-20'>
        <ConnectWalletMessage />
      </div>
    );
  }

  return (
    <>
      <Container fullWidth>
        <div className='flex flex-col gap-8'>
          {activeStep === 0 && <CityBuilderCitySelector myCities={myCities} />}
          {activeStep === 1 && <CityBuilderCityEditor />}
          {activeStep === 2 && <CityBuilderCityConfirm allCities={allCities} />}
        </div>
      </Container>
    </>
  );
};

const PageHeader = ({ heading, description }) => {
  const { steps, activeStep } = useCityBuilder();
  const { address } = useAlgo();

  return (
    <div>
      <div className={clsx('bg-gray-900 pt-10 pb-10 mb-12 md:mb-16')}>
        <Container fullWidth>
          <div className='flex lg:flex-row flex-col gap-10 lg:gap-3 lg:justify-between items-end'>
            <div className='flex-shrink-0 mr-16'>
              <h1 className='text-3xl font-extrabold text-gray-200 sm:text-5xl md:text-6xl'>{heading}</h1>
              <div className='max-w-xl mt-4'>
                <h2 className='text-base text-gray-500 md:text-xl'>{description}</h2>
              </div>
            </div>
            {address && (
              <div className='w-full'>
                <Steps steps={steps} activeStep={activeStep} />
              </div>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

const CityBuilder = () => {
  return (
    <CityBuilderProvider>
      <PageHeader
        heading='Shitty City Builder'
        description={`Make your cities even shittier by purchasing an Upgrade or adding Shitty City Blocks.`}
      />
      <LocalCityBuilder />
    </CityBuilderProvider>
  );
};

export default CityBuilder;
